import { api } from './api.ts';
import { cipher } from './session.ts';
import type { WebzineIssue } from '@/types/webzine.ts';
import type { DaoApiPagination, DaoApiResponse } from '@/types/dao.ts';

/**
 * 웹진 API.
 *
 * 백엔드 `ControllerApiWebzine`. 응답이 `WebzineIssue` 와 같은 모양이라 화면은
 * 받은 값을 그대로 쓴다.
 *
 * ★ 본문을 문단·줄 배열로 나누는 일은 **서버가 한다.** 화면마다 쪼개면 같은 글이
 *   화면마다 달리 보인다.
 *
 * 로그인이 필요 없는 읽기 전용 콘텐츠지만, 다른 API 와 같은 규약으로 본문을
 * AES-GCM 으로 감싸 보낸다.
 */

/** 목록 (최신 호가 앞) */
export async function fetchWebzineIssues(
  page = 1
): Promise<DaoApiResponse<DaoApiPagination<WebzineIssue>>> {
  const encrypted = await cipher.encryptJson({ p: page });
  return api.post<DaoApiResponse<DaoApiPagination<WebzineIssue>>>(
    '/api/webzine/items.json',
    encrypted
  );
}

/** 한 호 */
export async function fetchWebzineIssue(slug: string): Promise<DaoApiResponse<WebzineIssue>> {
  const encrypted = await cipher.encryptJson({ slug });
  return api.post<DaoApiResponse<WebzineIssue>>('/api/webzine/data.json', encrypted);
}
